module.exports = __webpack_public_path__ + "img/help-icon.5079a3dc.png";